<script>
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { MDCSwitch } from '@material/switch';
  import APIClient from '../../../state-charts/api-client';
  import { download_file } from '../../../lib/utils.js';

  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';

  // component options  ------------------------------------------------------ //

  export let order;
  // internal variables ------------------------------------------------------ //

  let dialog;
  let switcher;
  let switcher_value = true;

  // translate --------------------------------------------------------------- //

  // utility functions -------------------------------------------------------- //

  const init_dialog = () => {
    dialog = new MDCDialog(document.querySelector(`#certificate_id`));
    switcher = new MDCSwitch(document.querySelector('.mdc-switch'));
  };

  const toggle_switcher = () => {
    switcher_value = !switcher_value;
  };

  export const open = () => dialog.open();

  export const close = () => dialog.close();

  const download = async () => {
    let response = await APIClient.get_certificate(
      order.order_uuid,
      switcher_value
    );
    download_file(response.url, 'certification of completion.pdf');
  };

  onMount(init_dialog);
</script>

<!--<svelte:options accessors={true}></svelte:options>-->

<div id="certificate_id" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {t9n(TS.ORDER_GET_CERT)}
      </h2>

      <div class="mdc-dialog__content" id="my-dialog-content">
        {t9n(TS.ORDER_CERT_ADD)}
        <br />
        <br />
        {t9n(TS.ORDER_ADD_FBACK_DONT)}
        <a
          style="margin: 5px;"
          href="javascript:;"
          on:click={() => toggle_switcher()}>
          <div
            class="mdc-switch"
            class:mdc-switch--disabled={!switcher_value}
            class:mdc-switch--checked={switcher_value}>
            <div class="mdc-switch__track" />
            <div class="mdc-switch__thumb-underlay">
              <div class="mdc-switch__thumb" />
              <input
                type="checkbox"
                id="another-basic-switch"
                class="mdc-switch__native-control"
                role="switch"
                aria-checked="true"
                checked />
            </div>
          </div>
        </a>
        {t9n(TS.ORDER_ADD_FBACK)}
      </div>

      <footer class="mdc-dialog__actions">
        <button
          class="mdc-button mdc-button--raised"
          on:click|preventDefault|stopPropagation={close}>
          {t9n(TS.LOGIN_FORM_CLOSE)}
        </button>
        <button
          class="btn-close mdc-button mdc-button--raised"
          on:click|preventDefault|stopPropagation={async () => { await download() } }>
          {t9n(TS.ORDER_CERT_DOWNL)}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  a,
  a:active,
  a:focus {
    outline: none;
  }

  tr {
    text-align: left;
  }

  .mdc-dialog {
    text-align: center;
  }

  .mdc-dialog__content {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    letter-spacing: 0.03125em;
    text-decoration: inherit;
    text-transform: inherit;
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0;
    padding: 20px 24px;
    padding-top: 20px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mdc-dialog__title {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1.25rem;
    line-height: 2rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    text-decoration: inherit;
    text-transform: inherit;
    display: block;
    position: relative;
    flex-shrink: 0;
    box-sizing: border-box;
    margin: 0;
    padding: 0 24px 9px;
    border-bottom: 1px solid transparent;
  }

  .mdc-dialog__actions {
    display: flex;
    position: relative;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    min-height: 52px;
    margin: 0;
    padding: 8px;
    border-top: 1px solid transparent;
  }

  .btn-close {
    margin-left: 5px;
  }
</style>
